import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'react-redux';
import type { MediaGalleryState } from './types';

export const MediaGallery = (state: RootState) => state.mediaGallery;

export const getIsFetchingMedia = createSelector(
  MediaGallery,
  (state: MediaGalleryState) => state.isFetching,
);

export const getIsAppendFetching = createSelector(
  MediaGallery,
  (state: MediaGalleryState) => state.isAppendFetching,
);

export const getMediaGalleryData = createSelector(
  MediaGallery,
  (state: MediaGalleryState) => state.data,
);

export const getMediaGalleryContents = createSelector(
  getMediaGalleryData,
  (state: MediaGalleryState['data']) => state.contents,
);
